import './FullScreenPopup.css'
import * as React from 'react';
import {AppBar, Button, Dialog, Slide, Toolbar, Typography} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

class FullScreenPopup extends React.Component {

  render() {
    return (
      <Dialog fullScreen open={this.props.open} onClose={this.props.onClose} TransitionComponent={Transition}>
        <AppBar sx={{position: 'relative'}} className="fullscreen-popup-appbar">
          <Toolbar>
            <Typography sx={{flex: 1}} variant="h6" component="div" className="fullscreen-popup-title">
              {this.props.title}
            </Typography>
            <Button color="inherit" onClick={this.props.onClose}>
              <CloseIcon/>
            </Button>
          </Toolbar>
        </AppBar>
        {this.props.children}
      </Dialog>
    );
  }
}

export default FullScreenPopup;
